import React, { useState, useEffect } from "react";
import Layout from "../../Components/Navigation/Layout";
import axios from "axios";
import { FaEdit, FaTimes, FaSave, FaStore, FaEnvelope, FaCalendarAlt, FaQuoteLeft } from "react-icons/fa";
import SkeletonLoader from "../../Components/Loader";

const ShopDetail = () => {
  const [email, setEmail] = useState("");
  const [shopName, setShopName] = useState("");
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [id, setId] = useState(null);
  const [toast, setToast] = useState(null);

  const [formData, setFormData] = useState({
    Email: "", Message: "", Shop_Name: "", Rate_Date: "",
    item1: "", item2: "", item3: "", item4: "", item5: "", item6: "", item7: "",
    item1_Price: "", item2_Price: "", item3_Price: "", item4_Price: "",
    item5_Price: "", item6_Price: "", item7_Price: "",
  });

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const userEmail = user.Email || "";
    const userName = user.Shop_Name || "";
    setEmail(userEmail);
    setShopName(userName);
    if (userEmail) fetchData(userEmail, userName);
    else setLoading(false);
  }, []);

  const showToast = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3000);
  };

  const fetchData = async (e, s) => {
    try {
      const res = await axios.get("/server/baos_function/getRates/" + e);
      const data = res.data.data;
      if (data && data.length > 0 && data[0].Jewel_Rate) {
        const r = data[0].Jewel_Rate;
        setFormData({
          Email: r.Email || e, Message: r.Message || "", Shop_Name: r.Shop_Name || s,
          Rate_Date: r.Rate_Date || "",
          item1: r.item1||"", item2: r.item2||"", item3: r.item3||"", item4: r.item4||"",
          item5: r.item5||"", item6: r.item6||"", item7: r.item7||"",
          item1_Price: r.item1_Price||"", item2_Price: r.item2_Price||"",
          item3_Price: r.item3_Price||"", item4_Price: r.item4_Price||"",
          item5_Price: r.item5_Price||"", item6_Price: r.item6_Price||"", item7_Price: r.item7_Price||"",
        });
        setId(r.ROWID);
      } else {
        setFormData(prev => ({ ...prev, Email: e, Shop_Name: s }));
      }
    } catch (err) {
      console.error(err);
      showToast("Error fetching rates", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => setFormData(p => ({ ...p, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const form = new FormData();
      form.append("data", JSON.stringify(formData));
      const url = id ? `/server/baos_function/updateRate/${id}` : `/server/baos_function/addRate`;
      const res = await axios.post(url, form, { headers: { "Content-Type": "multipart/form-data" } });
      if (res.status === 200) {
        showToast("Rates updated successfully!");
        setIsEditing(false);
        if (!id && res.data.data?.ROWID) setId(res.data.data.ROWID);
      }
    } catch (err) {
      showToast("Error updating rates", "error");
    }
  };

  if (loading) return <Layout><SkeletonLoader /></Layout>;

  return (
    <Layout>
      <style>{`
        .sd-wrap { max-width: 900px; margin: 0 auto; width: 100%; animation: sd-fade .5s ease; }
        @keyframes sd-fade { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:translateY(0)} }
        
        .sd-card {
          background: #fff; border-radius: 16px; border: 1.5px solid #CBCBCB;
          box-shadow: 0 4px 20px rgba(0,0,0,.06); overflow: hidden;
        }
        
        .sd-hdr {
          background: linear-gradient(135deg, #0B2E33, #4F7C82);
          padding: 24px 30px; display: flex; align-items: center; justify-content: space-between;
          color: #B8E3E9;
        }
        .sd-title { font-size: 18px; font-weight: 800; color: #fff; display: flex; align-items: center; gap: 10px; }
        .sd-edit-btn {
          background: rgba(255,255,255,.15); border: 1.5px solid rgba(255,255,255,.2);
          color: #fff; padding: 8px 16px; border-radius: 10px; font-size: 13px; font-weight: 600;
          cursor: pointer; display: flex; align-items: center; gap: 8px; transition: all .2s;
        }
        .sd-edit-btn:hover { background: rgba(255,255,255,.25); }

        .sd-body { padding: 30px; display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px; }
        .sd-fg { display: flex; flex-direction: column; gap: 6px; }
        .sd-fg.full { grid-column: span 2; }
        .sd-lbl { font-size: 11px; font-weight: 700; color: #4F7C82; text-transform: uppercase; letter-spacing: .8px; }
        .sd-iw {
          display: flex; align-items: center; gap: 10px;
          border: 1.5px solid #CBCBCB; border-radius: 10px;
          padding: 10px 14px; background: #F2F2F2; transition: all .2s;
        }
        .sd-iw:focus-within { border-color: #0B2E33; background: #fff; box-shadow: 0 0 0 3px rgba(11,46,51,.08); }
        .sd-ico { color: #CBCBCB; font-size: 14px; }
        .sd-inp { border: none; background: transparent; outline: none; font-size: 14px; color: #0B2E33; width: 100%; font-family: 'Inter', sans-serif; }
        .sd-inp:disabled { color: #9ca3af; cursor: not-allowed; }
        .sd-txt { border: none; background: transparent; outline: none; font-size: 14px; color: #0B2E33; width: 100%; min-height: 80px; resize: vertical; font-family: 'Inter', sans-serif; }

        .sd-ftr { padding: 20px 30px; border-top: 1.5px solid #F2F2F2; display: flex; justify-content: flex-end; }
        .sd-save-btn {
          background: linear-gradient(135deg, #0B2E33, #4F7C82);
          color: #B8E3E9; border: none; padding: 12px 30px; border-radius: 12px;
          font-size: 14px; font-weight: 700; cursor: pointer; transition: opacity .2s;
          display: flex; align-items: center; gap: 8px; box-shadow: 0 4px 12px rgba(11,46,51,.25);
        }
        .sd-save-btn:hover { opacity: .9; }
        
        .ut-toast {
          position:fixed;top:20px;right:22px;z-index:3000;
          padding:12px 20px;border-radius:12px;font-size:14px;font-weight:500;color:#fff;
          display:flex;align-items:center;gap:10px;animation:sd-fade .3s ease;
          box-shadow:0 8px 24px rgba(0,0,0,.18);
        }
        .ut-toast.success{background:linear-gradient(135deg,#0B2E33,#4F7C82);}
        .ut-toast.error{background:linear-gradient(135deg,#931B5B,#6b1443);}

        @media(max-width: 600px) {
          .sd-body { grid-template-columns: 1fr; }
          .sd-fg.full { grid-column: span 1; }
        }
      `}</style>

      {toast && <div className={`ut-toast ${toast.type}`}>{toast.type==="success"?"✅":"❌"} {toast.msg}</div>}

      <div className="sd-wrap">
        <form className="sd-card" onSubmit={handleSubmit}>
          <div className="sd-hdr">
            <div className="sd-title">
              <FaStore /> {isEditing ? "Update Shop Rates" : "Shop Rate Details"}
            </div>
            <button type="button" className="sd-edit-btn" onClick={() => setIsEditing(!isEditing)}>
              {isEditing ? <><FaTimes /> Cancel</> : <><FaEdit /> Edit Rates</>}
            </button>
          </div>

          <div className="sd-body">
            <div className="sd-fg">
              <label className="sd-lbl">Shop Name</label>
              <div className="sd-iw">
                <FaStore className="sd-ico" />
                <input className="sd-inp" name="Shop_Name" value={formData.Shop_Name} disabled />
              </div>
            </div>

            <div className="sd-fg">
              <label className="sd-lbl">Registered Email</label>
              <div className="sd-iw">
                <FaEnvelope className="sd-ico" />
                <input className="sd-inp" name="Email" value={formData.Email} disabled />
              </div>
            </div>

            <div className="sd-fg full">
              <label className="sd-lbl">Rate Effective Date</label>
              <div className="sd-iw">
                <FaCalendarAlt className="sd-ico" />
                <input className="sd-inp" type="date" name="Rate_Date" value={formData.Rate_Date} onChange={handleChange} disabled={!isEditing} required />
              </div>
            </div>

            {[1,2,3,4,5,6,7].map(i => (
              <React.Fragment key={i}>
                <div className="sd-fg">
                  <label className="sd-lbl">Item {i} Label</label>
                  <div className="sd-iw">
                    <input className="sd-inp" name={`item${i}`} value={formData[`item${i}`]} onChange={handleChange} placeholder="e.g. Gold 24K" disabled={!isEditing} required />
                  </div>
                </div>
                <div className="sd-fg">
                  <label className="sd-lbl">Price / Rate</label>
                  <div className="sd-iw">
                    <input className="sd-inp" name={`item${i}_Price`} value={formData[`item${i}_Price`]} onChange={handleChange} placeholder="e.g. 7500" disabled={!isEditing} required />
                  </div>
                </div>
              </React.Fragment>
            ))}

            <div className="sd-fg full">
              <label className="sd-lbl">Scrolling Board Message</label>
              <div className="sd-iw">
                <FaQuoteLeft className="sd-ico" style={{ alignSelf: 'flex-start', marginTop: '5px' }} />
                <textarea className="sd-txt" name="Message" value={formData.Message} onChange={handleChange} placeholder="Message to show on the digital display..." disabled={!isEditing} />
              </div>
            </div>
          </div>

          {isEditing && (
            <div className="sd-ftr">
              <button type="submit" className="sd-save-btn">
                <FaSave /> Update All Rates
              </button>
            </div>
          )}
        </form>
      </div>
    </Layout>
  );
};

export default ShopDetail;
